import React from "react";
import WebGLApp, { OBJKTS_ENABLED } from "./webgl/webgl-app";
import ArtistModal from "./artist-modal/artist-modal";
import InfoModal from "./info-modal/info-modal";
import { gui } from "./webgl/utils/gui";
import curation from "./webgl/data/curation";

class App extends React.PureComponent {
  state = {
    artistModalVisible: false,
    infoModalVisible: false,
    objktID: curation.curation.artists[0].objktID,
    // objktID: 146722,
  };

  componentDidMount() {
    if (this.container === null) return;
    this.webglApp = new WebGLApp(this.container);
    this.webglApp.render(true);
    window.addEventListener("resize", this.onResize);
    this.onResize();

    if (OBJKTS_ENABLED) {
      this.webglApp.objkts.on("click", (objktID) => {
        this.setState({
          objktID,
          artistModalVisible: true,
        });
      });

      this.webglApp.objkts.title.on("click", () => {
        this.setState({
          infoModalVisible: true,
        });
      });
    }

    this.obj = {
      artistModalVisible: this.state.artistModalVisible,
      infoModalVisible: this.state.infoModalVisible,
    };

    gui
      .add(this.obj, "artistModalVisible")
      .onChange((artistModalVisible) => {
        this.setState({
          artistModalVisible,
        });
      })
      .listen();
  }

  componentWillUnmount() {
    if (this.container === null) return;
    this.webglApp.render(false);
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.webglApp.resize(window.innerWidth, window.innerHeight);
    // this.webglApp.resize(1500, 983);
  };

  onArtistModalClose = () => {
    this.obj.artistModalVisible = false;
    this.setState({
      artistModalVisible: false,
    });
  };

  onInfoModalClose = () => {
    this.obj.infoModalVisible = false;
    this.setState({
      infoModalVisible: false,
    });
  };

  render() {
    return (
      <div
        className="App"
        ref={(node) => {
          this.container = node;
        }}
      >
        <ArtistModal
          objktID={this.state.objktID}
          visible={this.state.artistModalVisible}
          onClose={this.onArtistModalClose}
        />
        <InfoModal
          visible={this.state.infoModalVisible}
          onClose={this.onInfoModalClose}
        />
      </div>
    );
  }
}

export default App;
